"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getApiUrl = void 0;
var _index = require("../utils/index");
var _globalDataContext = _interopRequireDefault(require("../lib/globalDataContext"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
var getApiUrl = (url, calcType) => {
  var calcsSupportDataScienceApi = ['reqdminimum'];
  var supportsDataScienceApi = calcsSupportDataScienceApi.includes(calcType);
  return supportsDataScienceApi ? getDataScienceApiUrlHost() + (0, _index.appendSlashPrefixIfNeeded)(url) : (0, _index.getMMDomainUrl)(url, false, true, true);
};

/**
 * Returns data science api host
 *
 * @returns {string} data science api host
 */
exports.getApiUrl = getApiUrl;
var getDataScienceApiUrlHost = () => {
  var appEnv = _globalDataContext.default.env;
  if (appEnv === 'prod') return 'https://apis.massmutual.com';else if (appEnv === 'preview') return 'https://apis.massmutual.com';else if (appEnv === 'qa') return 'https://apis-qa.massmutual.com';else return 'https://apis-dev.massmutual.com';
};